import React from 'react';
import NavBar from '../../components/NavBar';
import PlayersTable from './PlayersTable'; 

export default function Players() {
  return (
    <div>
      <h1 className="page-title"> Player Stats</h1>
      <PlayersTable />
    </div>
  );
}